import _extends from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
import { Flex } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var ContentZone = function ContentZone(props) {
  return ___EmotionJSX(Flex, _extends({
    "data-testid": "modal-upsellModal",
    flexDirection: "column",
    alignItems: "center",
    fontFamily: "onePass",
    color: "onePass.textPrimary",
    px: {
      sm: 2,
      md: 10
    }
  }, props));
};
export var DivisionIconsZone = function DivisionIconsZone(props) {
  return ___EmotionJSX(Flex, _extends({
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: "8xl",
    mb: 6
  }, props));
};
export var BenefitItemZone = function BenefitItemZone(props) {
  return ___EmotionJSX(Flex, _extends({
    py: 2,
    fontSize: {
      xs: "sm",
      md: "base"
    }
  }, props));
};
export var PricingZone = function PricingZone(props) {
  return ___EmotionJSX(Flex, _extends({
    mb: 3,
    alignItems: "flex-end"
  }, props));
};
export var SecondaryCTAZone = function SecondaryCTAZone(props) {
  return ___EmotionJSX(Flex, _extends({
    mt: 4,
    alignItems: "end",
    fontWeight: "bold",
    fontSize: "xs"
  }, props));
};